const mobileOrderRouter = [
  {
    path: "/mobileOrdering/login",
    name: "mobileOrderingLogin",
    component: () => import("@/components/page/mobileOrdering/login/login")
  },
  {
    path: "/mobileOrdering/networkTest",
    name: "mobileOrderingNetworkTest",
    component: () =>
      import("@/components/page/mobileOrdering/login/networkTest")
  },
  {
    path: "/mobileOrdering/selectClass",
    name: "mobileOrderingSelectClass",
    component: () =>
      import("@/components/page/mobileOrdering/login/selectClass")
  },
  {
    path: "/mobileOrdering/siteInfo",
    name: "mobileOrderingSiteInfo",
    component: () => import("@/components/page/mobileOrdering/login/siteInfo")
  },
  {
    path: "/mobileOrdering/index",
    name: "mobileOrderingIndex",
    component: () => import("@/components/page/mobileOrdering/index")
  },
  {
    path: "/mobileOrdering/preOrder",
    name: "mobileOrderingPreOrder",
    component: () =>
      import("@/components/page/mobileOrdering/preOrder/preOrder")
  },
  {
    path: "/mobileOrdering/mihotelPreOrder",
    name: "mobileOrderingMihotelPreOrder",
    component: () =>
      import("@/components/page/mobileOrdering/preOrder/cateringOrder")
  },
  {
    path: "/mobileOrdering/preOrderDetails",
    name: "mobileOrderingPreOrderDetails",
    component: () =>
      import("@/components/page/mobileOrdering/preOrder/preOrderDetails")
  },
  {
    path: "/mobileOrdering/preOrderList",
    name: "mobileOrderingPreOrderList",
    component: () =>
      import("@/components/page/mobileOrdering/preOrder/preOrderList")
  },
  {
    path: "/mobileOrdering/bill",
    name: "mobileOrderingBill",
    component: () => import("@/components/page/mobileOrdering/bill")
  },
  {
    path: "/mobileOrdering/home",
    name: "mobileOrderingSalesHome",
    component: () => import("@/components/page/mobileOrdering/home/home")
  },
  {
    path: "/mobileOrdering/changePassword",
    name: "mobileOrderingChangePassword",
    component: () =>
      import("@/components/page/mobileOrdering/home/changePassword")
  },
  {
    path: "/mobileOrdering/printSet",
    name: "mobileOrderingPrintSet",
    component: () => import("@/components/page/mobileOrdering/home/printSet")
  },
  {
    path: "/mobileOrdering/networkCheck",
    name: "mobileOrderingNetworkCheck",
    component: () =>
      import("@/components/page/mobileOrdering/home/networkCheck")
  },
  {
    path: "/mobileOrdering/versionInfo",
    name: "mobileOrderingVersionInfo",
    component: () =>
      import("@/components/page/mobileOrdering/home/versionInfo")
  },

  {
    path: "/mobileOrdering/salesPoints",
    name: "mobileOrderingSalesPoints",
    component: () => import("@/components/page/mobileOrdering/salesPoints")
  },
  {
    path: "/mobileOrdering/openTable",
    name: "mobileOrderingOpenTable",
    component: () => import("@/components/page/mobileOrdering/openTable")
  },
  {
    path: "/mobileOrdering/myOrder",
    name: "mobileOrderingMyOrder",
    component: () => import("@/components/page/mobileOrdering/myOrder")
  },
  {
    path: "/mobileOrdering/SDishOperation",
    name: "mobileOrderingSDishOperation",
    component: () =>
      import("@/components/page/mobileOrdering/SDishOperation/SDishOperation")
  },
  {
    path: "/mobileOrdering/changeQuantity",
    name: "mobileOrderingChangeQuantity",
    component: () =>
      import("@/components/page/mobileOrdering/SDishOperation/changeQuantity")
  },
  {
    path: "/mobileOrdering/tasteMethod",
    name: "mobileOrderingTasteMethod",
    component: () =>
      import("@/components/page/mobileOrdering/SDishOperation/tasteMethod")
  },
  {
    path: "/mobileOrdering/returnDish",
    name: "mobileOrderingReturnDish",
    component: () =>
      import("@/components/page/mobileOrdering/SDishOperation/returnDish")
  },
  {
    path: "/mobileOrdering/tempDishModify",
    name: "mobileOrderingTempDishModify",
    component: () =>
      import("@/components/page/mobileOrdering/SDishOperation/tempDishModify")
  },
  {
    path: "/mobileOrdering/packageOperation",
    name: "mobileOrderingPackageOperation",
    component: () =>
      import(
        "@/components/page/mobileOrdering/SDishOperation/packageOperation"
      )
  },
  {
    path: "/mobileOrdering/selectedTableNum",
    name: "mobileOrderingSelectedTableNum",
    component: () =>
      import("@/components/page/mobileOrdering/selectedTableNum")
  },
  {
    path: "/mobileOrdering/pay",
    name: "mobileOrderingPay",
    component: () => import("@/components/page/mobileOrdering/pay/pay")
  },
  {
    path: "/mobileOrdering/cash",
    name: "mobileOrderingCash",
    component: () => import("@/components/page/mobileOrdering/pay/cash")
  },
  {
    path: "/mobileOrdering/storedCard",
    name: "mobileOrderingStoredCard",
    component: () => import("@/components/page/mobileOrdering/pay/storedCard")
  },
  {
    path: "/mobileOrdering/bankCard",
    name: "mobileOrderingBankCard",
    component: () => import("@/components/page/mobileOrdering/pay/bankCard")
  },
  {
    path: "/mobileOrdering/scanCode",
    name: "mobileOrderingScanCode",
    component: () => import("@/components/page/mobileOrdering/pay/scanCode")
  },
  {
    path: "/mobileOrdering/turnFront",
    name: "mobileOrderingTurnFront",
    component: () => import("@/components/page/mobileOrdering/pay/turnFront")
  },
  {
    path: "/mobileOrdering/turnAR",
    name: "mobileOrderingTurnAR",
    component: () => import("@/components/page/mobileOrdering/pay/turnAR")
  },
  {
    path: "/mobileOrdering/prePay",
    name: "mobileOrderingPrePay",
    component: () => import("@/components/page/mobileOrdering/pay/prePay")
  },
  {
    path: "/mobileOrdering/hospitality",
    name: "mobileOrderingHospitality",
    component: () => import("@/components/page/mobileOrdering/pay/hospitality")
  },
  {
    path: "/mobileOrdering/orderDish",
    name: "mobileOrderingOrderDish",
    component: () => import("@/components/page/mobileOrdering/orderDish")
  },
  {
    path: "/mobileOrdering/shoppingCart",
    name: "mobileOrderingShoppingCart",
    component: () => import("@/components/page/mobileOrdering/shoppingCart")
  }
];
export default mobileOrderRouter;



// WEBPACK FOOTER //
// ./src/router/modules/mobileOrderRouter.js